





























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { FarmProfile } from '@/interfaces';

@Component
export default class FarmAuthorizationStatus extends Vue {
    @Prop({default: false}) public farm!: FarmProfile;

}
